import { ActionContext, MutationTree } from "vuex"
import { getValidAttachmentTypes } from "@/controllers/global/attachments"

type State = {
  validTypes: Set<string>
}
type Context = ActionContext<State, any>

export enum MutationTypes {
    SET_VALID_TYPES = "SET_VALID_TYPES"
}

const state: State = {
  validTypes: new Set()
}

const actions = {
  async fetchValidTypes ({ commit }: Context) {
    const types = await getValidAttachmentTypes()
    commit(MutationTypes.SET_VALID_TYPES, types)
  }
}

const mutations: MutationTree <State> = {
  [MutationTypes.SET_VALID_TYPES] (state, types: Set<string>) {
    state.validTypes = types
  }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}